<template>
  <q-page-sticky position="bottom-right" :offset="[18, 50]">
    <slot />
  </q-page-sticky>
</template>

